import React from "react";
import "./Skill.css";
import { BsPatchCheckFill } from "react-icons/bs";
// fronted images
import html from "../../assets/skills/frontend/html.svg";
import css from "../../assets/skills/frontend/css.svg";
import JavaScript from "../../assets/skills/frontend/javascipt.svg";
import redux from "../../assets/skills/frontend/redux.svg";
import tailwind from "../../assets/skills/frontend/tailwind.svg";
import chakra from "../../assets/skills/frontend/chakra.svg";
import react from "../../assets/skills/frontend/react.svg";
import materialui from "../../assets/skills/frontend/material-ui.svg";
import restapi from "../../assets/skills/frontend/restapi.svg";

// backend images
import nodejs from "../../assets/skills/backend/nodejs.svg";
import mongodb from "../../assets/skills/backend/mongodb.svg";
import mongoose from "../../assets/skills/backend/mongoose.svg";
import express from "../../assets/skills/backend/express.svg";

// tools images
import heroku from "../../assets/skills/tools/heroku.svg";
import netlify from "../../assets/skills/tools/netlify.svg";
import vercel from "../../assets/skills/tools/vercel.svg";
import git from "../../assets/skills/tools/git.svg";
import github from "../../assets/skills/tools/github.svg";
import npm from "../../assets/skills/tools/npm.svg";
import vs from "../../assets/skills/tools/vs.svg";
import postman from "../../assets/skills/tools/postman.svg";


const Skill = () => {
  return (
    <section id="skill">
    
      <h2>My Skills</h2>
      <div className="container experience_container">
        <div className="experience_frontend">
          <h3>Frontend Development</h3>
          <div className="experience_content">
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
               
                <img src={html} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
               
                <img src= {css} alt="" />
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                {/* <h4>JavaScript</h4> */}
                <img src={JavaScript} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                {/* <h4>Redux</h4> */}
                <img src={redux} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                {/* <h4>Tailwind</h4> */}
                <img src={tailwind} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
            
                <img src={react} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>

            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
             
                <img src={chakra} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
             
                <img src={materialui} alt="" />
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                
                <img src={restapi} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                {/* <h4>React</h4> */}
                <img src="https://camo.githubusercontent.com/4f9d20f3a284d2f6634282f61f82a62e99ee9906537dc9859decfdc9efbb51ec/68747470733a2f2f696d672e736869656c64732e696f2f62616467652f52656163745f526f757465722d4341343234353f7374796c653d666f722d7468652d6261646765266c6f676f3d72656163742d726f75746572266c6f676f436f6c6f723d7768697465" alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
          </div>
        </div>

     
        
        <div className="experience_backend">
          <h3>Backend Development</h3>
          <div className="experience_content">
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
               
                <img src={nodejs} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                {/* <h4>MongoDB</h4> */}
                <img src={mongodb} alt="" />
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
                {/* <h4>PHP</h4> */}
                <img src={mongoose} alt="" />
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
             
                <img src={express} alt="" />
                <small className="text-light">Basic</small>
              </div>
            </article>
      
          </div>
        </div>


     

        <div className="experience_backend">
          <h3>Tools</h3>
          <div className="experience_content">
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
          
                <img src={heroku} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
             <img src={netlify} alt="" />
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
               <img src={vercel} alt="" />
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
              <img src={git} alt="" />
                <small className="text-light">Basic</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
             <img src={github} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
             <img src={npm} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
             <img src={vs} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="experience_details">
              <BsPatchCheckFill className="experience_details-icon" />
              <div>
             <img src={postman} alt="" />
                <small className="text-light">Experienced</small>
              </div>
            </article>
          </div>
        </div>
      </div>
      
    </section>
  );
};

export default Skill;